(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chill-discovery"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('chill-discovery')) return;
  let instanceCount = 0;

  class ChillDiscovery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.form = this.querySelector('[data-hero-form]');
      this.input = this.querySelector('[data-hero-input]');
      this.results = this.querySelector('[data-hero-results]');
      this.status = this.querySelector('[data-hero-status]');
      if (!this.form || !this.input || !this.results || !this.status) return;

      this.initialized = true;
      this.requestVersion = (this.requestVersion || 0) + 1;
      this.activeIndex = -1;
      this.options = [];
      this.resultQuery = '';
      this.composing = false;
      this.events = new AbortController();
      const opts = { signal: this.events.signal };

      const shortPlaceholder = this.input.dataset.placeholderShort;
      if (shortPlaceholder && window.matchMedia && window.matchMedia('(max-width: 639px)').matches) {
        this.input.placeholder = shortPlaceholder;
      }
      if (!this.results.id) this.results.id = `chd-results-${++instanceCount}`;
      this.input.setAttribute('aria-controls', this.results.id);
      this.closeResults();

      this.input.addEventListener('input', () => { if (!this.composing) this.scheduleSearch(); }, opts);
      this.input.addEventListener('focus', () => this.scheduleSearch(), opts);
      this.input.addEventListener('blur', () => this.cancelAndClose(), opts);
      this.input.addEventListener('compositionstart', () => { this.composing = true; this.cancelAndClose(); }, opts);
      this.input.addEventListener('compositionend', () => { this.composing = false; this.scheduleSearch(); }, opts);
      this.input.addEventListener('keydown', (event) => this.onKeydown(event), opts);
      this.form.addEventListener('submit', () => this.cancelAndClose(), opts);

      this.results.addEventListener('pointerdown', (event) => {
        const option = event.target.closest('[role="option"]');
        if (option && this.results.contains(option) && event.button === 0) event.preventDefault();
      }, opts);
      this.results.addEventListener('click', (event) => {
        const option = event.target.closest('[role="option"]');
        const index = this.options.findIndex((item) => item.element === option);
        if (index < 0) return;
        event.preventDefault();
        this.navigate(index);
      }, opts);
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) this.cancelAndClose();
      }, opts);
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.cancelAndClose();
      this.events.abort();
      this.initialized = false;
    }

    cancelRequest() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = undefined;
      this.requestVersion += 1;
      if (this.request) this.request.abort();
      this.request = undefined;
      this.results.removeAttribute('aria-busy');
    }

    cancelAndClose() {
      this.cancelRequest();
      this.closeResults();
      this.status.textContent = '';
    }

    closeResults() {
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.selectOption(-1);
    }

    scheduleSearch() {
      this.cancelAndClose();
      const query = this.input.value.trim();
      if (query.length < 2 || document.activeElement !== this.input) return;
      this.debounceTimer = setTimeout(() => this.search(query), 180);
    }

    sameOriginURL(value) {
      try {
        const url = new URL(value, window.location.origin);
        return url.origin === window.location.origin && /^https?:$/.test(url.protocol) ? url : null;
      } catch {
        return null;
      }
    }

    searchURL(query) {
      const url = this.sameOriginURL(this.dataset.searchUrl || this.form.action);
      if (!url) return null;
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      url.searchParams.set('q', query);
      return url.href;
    }

    async search(query) {
      this.debounceTimer = undefined;
      if (!this.isConnected || document.activeElement !== this.input || query !== this.input.value.trim()) return;
      const endpoint = this.sameOriginURL(this.dataset.predictiveUrl || '');
      if (!endpoint) return;
      endpoint.pathname = `${endpoint.pathname.replace(/\/$/, '').replace(/\.json$/, '')}.json`;
      endpoint.searchParams.set('q', query);
      endpoint.searchParams.set('resources[type]', 'product');
      endpoint.searchParams.set('resources[limit]', '6');
      endpoint.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,variants.sku,vendor');
      endpoint.searchParams.set('resources[options][unavailable_products]', 'last');

      const version = ++this.requestVersion;
      const request = new AbortController();
      this.request = request;
      this.results.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loadingLabel || 'Searching';

      try {
        const response = await fetch(endpoint.href, {
          method: 'GET', mode: 'same-origin', credentials: 'same-origin', redirect: 'error',
          headers: { Accept: 'application/json' }, signal: request.signal
        });
        if (!response.ok) throw new Error('Predictive search unavailable');
        const payload = await response.json();
        if (!this.isCurrentRequest(version, query)) return;
        const products = payload?.resources?.results?.products;
        if (!Array.isArray(products)) throw new Error('Invalid predictive search response');
        this.renderResults(products.slice(0, 6), query);
      } catch (error) {
        if (error.name !== 'AbortError' && this.isCurrentRequest(version, query)) {
          this.closeResults();
          this.status.textContent = '';
        }
      } finally {
        if (version === this.requestVersion) {
          this.results.removeAttribute('aria-busy');
          this.request = undefined;
        }
      }
    }

    isCurrentRequest(version, query) {
      return this.isConnected && version === this.requestVersion &&
        document.activeElement === this.input && query === this.input.value.trim() && !this.composing;
    }

    renderResults(products, query) {
      this.options = [];
      this.activeIndex = -1;
      this.results.replaceChildren();
      this.input.removeAttribute('aria-activedescendant');
      this.resultQuery = query;

      products.forEach((product) => {
        if (!product || typeof product.title !== 'string' || typeof product.url !== 'string') return;
        const destination = this.sameOriginURL(product.url);
        if (!destination) return;
        const option = this.createOption(product.title, destination.href);
        const priceLabel = this.formatPrice(product);
        if (priceLabel) {
          const price = document.createElement('span');
          price.className = 'chd__result-price';
          price.textContent = priceLabel;
          option.append(price);
        }
        const imageValue = typeof product.featured_image === 'string'
          ? product.featured_image : product.featured_image?.url || product.image;
        if (typeof imageValue === 'string' && imageValue) {
          try {
            const imageURL = new URL(imageValue, window.location.origin);
            if (/^https?:$/.test(imageURL.protocol)) {
              if (/\.shopify\.com$/.test(imageURL.hostname)) imageURL.searchParams.set('width', '96');
              const image = document.createElement('img');
              image.src = imageURL.href;
              image.alt = '';
              image.width = 48;
              image.height = 48;
              image.loading = 'lazy';
              image.decoding = 'async';
              option.prepend(image);
            }
          } catch {
            /* skip image */
          }
        }
      });

      const count = this.options.length;
      const allResultsURL = this.searchURL(query);
      if (allResultsURL) {
        const option = this.createOption(this.dataset.viewAllLabel || 'See all results for', allResultsURL);
        option.classList.add('chd__result--all');
        const meta = document.createElement('span');
        meta.className = 'chd__result-meta';
        meta.textContent = `“${query}”`;
        option.append(meta);
      }

      this.results.hidden = this.options.length === 0;
      this.input.setAttribute('aria-expanded', String(this.options.length > 0));
      this.status.textContent = count
        ? (this.dataset.resultsLabel || 'Suggestions ready.')
        : (this.dataset.emptyLabel || 'No suggestions. Press Enter to search all products.');
    }

    formatPrice(product) {
      const min = Number.parseFloat(product.price_min ?? product.price);
      if (!Number.isFinite(min) || min <= 0) return '';
      const max = Number.parseFloat(product.price_max ?? product.price_min ?? product.price);
      const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: Number.isInteger(min) ? 0 : 2 }).format(min);
      return Number.isFinite(max) && max > min ? `from ${money}` : money;
    }

    createOption(title, href) {
      const option = document.createElement('div');
      option.id = `${this.results.id}-option-${this.options.length}`;
      option.className = 'chd__result';
      option.setAttribute('role', 'option');
      option.setAttribute('aria-selected', 'false');
      const label = document.createElement('span');
      label.className = 'chd__result-title';
      label.textContent = title;
      option.append(label);
      this.options.push({ element: option, href });
      this.results.append(option);
      return option;
    }

    selectOption(index) {
      this.activeIndex = index;
      this.options.forEach((option, optionIndex) => {
        option.element.setAttribute('aria-selected', String(optionIndex === index));
      });
      const active = this.options[index];
      if (active) {
        this.input.setAttribute('aria-activedescendant', active.element.id);
        active.element.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      } else {
        this.input.removeAttribute('aria-activedescendant');
      }
    }

    onKeydown(event) {
      if (event.isComposing || this.composing) return;
      if (event.key === 'Escape') {
        if (!this.results.hidden) event.preventDefault();
        this.cancelAndClose();
        return;
      }
      const hasCurrentOptions = this.options.length > 0 && this.resultQuery === this.input.value.trim();
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && hasCurrentOptions) {
        event.preventDefault();
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        const next = this.activeIndex < 0
          ? (direction > 0 ? 0 : this.options.length - 1)
          : (this.activeIndex + direction + this.options.length) % this.options.length;
        this.selectOption(next);
      } else if (!this.results.hidden && hasCurrentOptions) {
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.selectOption(event.key === 'Home' ? 0 : this.options.length - 1);
        } else if (event.key === 'Enter' && this.activeIndex >= 0) {
          event.preventDefault();
          this.navigate(this.activeIndex);
        }
      }
    }

    navigate(index) {
      const option = this.options[index];
      if (!option) return;
      const href = option.href;
      this.cancelAndClose();
      window.location.assign(href);
    }
  }

  customElements.define('chill-discovery', ChillDiscovery);
})();

  } catch(e) { console.error(e); }
})();
})();
